import { CORAL_600, GRAY_900 } from 'constants/styling/theme'
import { FC, useState } from 'react'
import { Stack, Typography } from '@mui/material'

import { BorderBoxWrapper } from 'components/common/BorderBoxWrapper'
import { DeleteWorkspacePopup } from 'components/pages/Workspace/DeleteWorkspacePopup'
import { MUIButton } from 'components/common/MUIButton'
import { MUITooltip } from 'components/common/MUITooltip'
import { SubscriptionStatus } from 'models/user/userWorkspaceDTOs'
import moment from 'moment-timezone'
import { useTranslation } from 'react-i18next'
import { useUserData } from 'components/contexts/UserDataContext'

export const DangerZoneModule: FC = () => {
  const { t } = useTranslation(['workspace_settings'])
  const { currentUserWorkspaceMembership, userWorkspacesQuery } = useUserData()

  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false)

  const terminatedAt = currentUserWorkspaceMembership?.terminatedAt
  const isInGracePeriod = currentUserWorkspaceMembership?.workspaceStatus === SubscriptionStatus.IN_GRACE_PERIOD
  // Don't trust the cached IN_GRACE_PERIOD value while membership data is being refetched
  // (e.g. right after a workspace switch) — wait for fresh data before allowing or blocking deletion.
  const isMembershipFetching = userWorkspacesQuery.isFetching

  return (
    <Stack gap="1.6rem">

      <Typography variant="text-xl" fontWeight={600} color={GRAY_900}>
        {t('workspace_settings:danger_zone.title')}
      </Typography>

      <BorderBoxWrapper padding="2.4rem">
        {!!terminatedAt && (
          <Typography variant="text-md" fontWeight={400} color={CORAL_600}>
            {t('workspace_settings:workspace_active_until', { date: moment(terminatedAt).format('DD.MM.YYYY') })}
          </Typography>
        )}

        {!terminatedAt && (
          <MUITooltip
            content={!isMembershipFetching && isInGracePeriod ? t('workspace_settings:danger_zone.delete_workspace_grace_period_tooltip') : undefined}
            placement="top"
            sx={{ width: '26rem' }}
          >
            <MUIButton
              type="orangeSecondaryBorder"
              disabled={isMembershipFetching || isInGracePeriod}
              isLoading={isMembershipFetching}
              onClick={() => setIsDeletePopupOpen(true)}
            >
              {t('workspace_settings:danger_zone.delete_workspace')}
            </MUIButton>
          </MUITooltip>
        )}
      </BorderBoxWrapper>

      {!terminatedAt && (
        <DeleteWorkspacePopup isOpen={isDeletePopupOpen} onClose={() => setIsDeletePopupOpen(false)} />
      )}

    </Stack>
  )
}
